function updateCardPrice(productCard) {
  const productDataEl = productCard.querySelector(".product-data");
  if (!productDataEl) return;

  const productData = JSON.parse(productDataEl.textContent);

  const priceContainer = productCard.querySelector(".card-price");
  if (!priceContainer) return;

  const moneyFormat = priceContainer.dataset.moneyFormat;
  const discountMode = priceContainer.dataset.discountMode;

  const checkedInput = productCard.querySelector('fieldset input[type="radio"]:checked');
  let selectedVariant;

  if (checkedInput) {
    const selectedColor = checkedInput.value;
    selectedVariant = productData.variants.find(variant => variant.option1 === selectedColor);
  } else {
    // --- ADAPTACIÓN INFALIBLE: BUSCAR POR ID DESDE EL ENLACE ---
    const swatches = productCard.querySelectorAll('fieldset a');
    let activeLink = null;
    
    // Buscamos cuál es la miniatura activa chequeando el borde
    swatches.forEach(swatch => {
      const borderCss = swatch.style.border || swatch.style.borderColor || '';
      if (borderCss.includes('#000') || borderCss.includes('0, 0, 0') || borderCss.includes('black')) {
        activeLink = swatch;
      }
    });

    if (activeLink) {
      // Extraemos el ID exacto desde la URL, esto no falla nunca
      const url = new URL(activeLink.href, window.location.origin);
      const variantId = url.searchParams.get('variant');

      if (variantId) {
        selectedVariant = productData.variants.find(v => v.id.toString() === variantId.toString());
      }
    }
  }

  // Si a pesar de todo no encuentra nada, usa la primera variante
  if (!selectedVariant) {
    selectedVariant = productData.variants[0];
  }

  if (!selectedVariant) return;

  // --- SALVAVIDAS: Por si el tema no trae Shopify.formatMoney nativo ---
  if (typeof Shopify === 'undefined') { window.Shopify = {}; }
  if (!Shopify.formatMoney) {
    Shopify.formatMoney = function(cents, format) {
      if (typeof cents == 'string') { cents = cents.replace('.', ''); }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = (format || '${{amount}}');
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision || 2; thousands = thousands || ','; decimal = decimal || '.';
        if (isNaN(number) || number == null) { return 0; }
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
      }
      const match = formatString.match(placeholderRegex);
      if (match) {
        switch(match[1]) {
          case 'amount': value = formatWithDelimiters(cents, 2); break;
          case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
          case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
        }
        return formatString.replace(placeholderRegex, value);
      }
      return (cents / 100.0).toFixed(2);
    };
  }

  const formattedPrice = Shopify.formatMoney(selectedVariant.price, moneyFormat);

  let html = "";

  if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
    const formattedCompare = Shopify.formatMoney(selectedVariant.compare_at_price, moneyFormat);
    let savingsText = "";

    if (discountMode === "percentage") {
      const percentage = Math.round(
        (selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price
      );
      savingsText = `-${percentage}%`;
    } else {
      const moneySaved = Shopify.formatMoney(selectedVariant.compare_at_price - selectedVariant.price, moneyFormat);
      savingsText = `-${moneySaved}`;
    }

    html = `
      <sale-price class="price-list__sale">
        <span class="sr-only">Precio de oferta</span>
        ${formattedPrice}
      </sale-price>
      <compare-at-price class="price-list__compare">
        <span class="sr-only">Precio original</span>
        ${formattedCompare}
      </compare-at-price>
      <on-sale-badge class="badge badge--on-sale">
        ${savingsText}
      </on-sale-badge>
    `;
  } else {
    html = `<sale-price class="price-list__price">${formattedPrice}</sale-price>`;
  }

  priceContainer.innerHTML = html;
}

function initNewCards(root = document) {
  root.querySelectorAll("product-card, .card, .product-card")
    .forEach(card => {
      if (card.dataset.priceInitialized) return; 
      card.dataset.priceInitialized = "true";
      updateCardPrice(card);
  });
}

function handleVariantChange(event) {
  const target = event.target;

  // Lógica original de la agencia para inputs tipo radio
  if (target.matches('input[type="radio"], select[name="id"]')) {
    const productCard = target.closest("product-card, .card, .product-card");
    if (!productCard) return;
    updateCardPrice(productCard);
  }

  // --- NUESTRA LÓGICA: Atrapa los clics en tus miniaturas ---
  const swatchLink = target.closest('fieldset a');
  if (swatchLink) {
    const productCard = swatchLink.closest("product-card, .card, .product-card");
    if (!productCard) return;
    
    // Un respiro mínimo para que la foto cambie antes de buscar el precio nuevo
    setTimeout(() => {
      updateCardPrice(productCard);
    }, 50);
  }
}

document.addEventListener("change", handleVariantChange);
document.addEventListener("click", handleVariantChange);

document.addEventListener("DOMContentLoaded", () => initNewCards());
document.addEventListener("shopify:section:load", () => initNewCards());

const observer = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== Node.ELEMENT_NODE) continue;

      if (node.matches("product-card, .card, .product-card")) {
        if (!node.dataset.priceInitialized) {
          node.dataset.priceInitialized = "true";
          updateCardPrice(node);
        }
      }
      
      if (node.querySelectorAll) {
         initNewCards(node);
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });

// Ejecutamos la función de una, por si el navegador ya terminó de cargar
initNewCards();